<script lang="ts">
  import { ref, type Ref } from 'vue'
  import { createContext } from 'reka-ui'

  export interface AppLoadingContext {
    loadingIds: Ref<Set<string>>
    setLoadingId: (id?: string | string[]) => void
    removeLoadingId: (id?: string | string[]) => void
    isLoading: (id?: string | string[]) => boolean
  }

  const [_useAppLoading, provideAppLoading] =
    createContext<AppLoadingContext>('gs-app-loading')

  export function useAppLoading() {
    try {
      return _useAppLoading()
    } catch (error) {
      console.warn('AppLoadingProvider not provided')
      return {
        loadingIds: new Set<string>(),
        setLoadingId: () => {},
        removeLoadingId: () => {},
        isLoading: () => false
      }
    }
  }
</script>

<script setup lang="ts">
  const loadingIds = ref(new Set<string>())

  function setLoadingId(id?: string | string[]) {
    if (!id) {
      return
    }
    if (Array.isArray(id)) {
      id.forEach((id) => {
        loadingIds.value.add(id)
      })
    } else {
      loadingIds.value.add(id)
    }
  }

  function removeLoadingId(id?: string | string[]) {
    if (!id) {
      return
    }
    if (Array.isArray(id)) {
      id.forEach((id) => {
        loadingIds.value.delete(id)
      })
    } else {
      loadingIds.value.delete(id)
    }
  }

  function isLoading(id?: string | string[]) {
    if (!id) {
      return false
    }
    if (Array.isArray(id)) {
      return id.some((id) => loadingIds.value.has(id))
    }
    return loadingIds.value.has(id)
  }

  provideAppLoading({
    loadingIds,
    setLoadingId,
    removeLoadingId,
    isLoading
  })
</script>

<template>
  <slot />
</template>
